import { Module } from '@nestjs/common'
import { CustomerMessageController, MessageController } from './controllers'
import { MessageService } from './services'

@Module({
	controllers: [MessageController, CustomerMessageController],
	providers: [MessageService],
})
export class MessageModule {}
